<template>
    <div>
        <b-row align-v="center" align-h="center">
            <b-col v-for="filter in filters" :key="filter.id">
                <b-btn
                    variant="link"
                    size="sm"
                    @click="$emit('filter', filter)"
                    block
                >
                    <app-nobr>
                        {{ filter.name }}
                    </app-nobr>
                </b-btn>
            </b-col>
        </b-row>
    </div>
</template>
<script>
export default {
    props: {
        filters: {
            type: Array,
            default: [],
        },
    },
    data: () => ({}),
    computed: {},
    methods: {},
}
</script>
